$(document).ready(function () {
  function updateHref() {
    if(!window.location.href.includes('/zh')) {
        $('#weglot-language-tw').attr('href', window.location.origin + '/zh' + window.location.pathname)
      } else {
      $('#weglot-language-tw').attr('href', window.location.href)
      }
      
      $('#weglot-language-en').attr('href', window.location.href.replace('zh/', ''))
  }
  $(document).on('click', '#wg-tw', function() {
    if(window.location.href.includes('/zh')) {
    } else {
      window.location.href = window.location.origin + '/zh' + window.location.pathname
    }
  }) 
  $(document).on('click', '#wg-en', function() {
    if(window.location.href.includes('/zh')) {
      window.location.href = window.location.href.replace('/zh', '');
    }
  }) 
    setTimeout(function(){
      	if ($('#wg-en').length > 0) { 
            $('.en-selected').addClass('active');
            $(".english-class-wrapper").hide();
            $(".taiwan-class-wrapper").show();
            $('.wgcurrent .wg-flag').attr("src","//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags.svg?v=107880432075996407961749031382"); 
            $('.zh-TW-selected').html('<img id="flag-icon" src="//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags-black.svg?v=97016998202084650651749031382" alt="flag"><span>English</span>');
		}else{
            $(".english-class-wrapper").show();
            $(".taiwan-class-wrapper").hide();
            $('.zh-TW-selected').addClass('active');
            $('.en-selected').html('<img id="flag-icon" src="//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags-black.svg?v=97016998202084650651749031382" alt="flag"><span>Chinese</span>');
        }
         $('.wg-flag').attr("src","//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags-black.svg?v=97016998202084650651749031382"); 
         $('.wgcurrent .wg-flag').attr("src","//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags.svg?v=107880432075996407961749031382"); 

        if($('#changeR').length == 0)
            $('.weglot-container ul').append('<li id="changeR"><a class="change-region" href="javascript:void(0)">Change region</a></li>');
      if(window.location.href.includes('/zh')) {
        $('[data-l="tw"]').click();
      }
      //https://www.specialized.com/sg/en/store-finder?coords=24.1326303%2C120.6841314&page=1
      // Update option href
      updateHref()
    }, 500);

  
    Weglot.on("languageChanged", function(newLang, prevLang) {
        // Start comment by mansi.
        
        $('.wg-flags .wg-flag').attr('src', "//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags-black.svg?v=97016998202084650651749031382"); 
        $('.wgcurrent .wg-flag').attr('src', "//specialized.com.tw/cdn/shop/t/91/assets/maps-and-flags.svg?v=107880432075996407961749031382"); 
        if(typeof newLang == "undefined"){
            newLang = "en";
        }
        if(newLang == 'en'){
        $(".english-class-wrapper").show();
        $(".taiwan-class-wrapper").hide();
        }else{ 
        $(".english-class-wrapper").hide();
        $(".taiwan-class-wrapper").show();
        }
        // End comment by mansi.      

    
        $(".tw-algolia-title" ).each(function( index ) {
           
            if($(this).text().trim().length == 0 ){
                $(this).closest(".aa-product-text").find('.en-algolia-title').attr('style','display:block !important'); 
                $(this).attr('style','display:none !important');
            }
        });
      setTimeout(() => updateHref(), 500)

    })



});





